import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { Provider } from './context';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const gutterToClassBindings = {
  collapse: 'gutterCollapse',
  small: 'gutterSmall',
  medium: 'gutterMedium',
  large: null,
};

const isProperGutterType = (key) => key in gutterToClassBindings;

const mapGutterToClass = (key) => gutterToClassBindings[key];

/**
 * returns { className, style } pair for given gutter
 */
const getGutterData = (gutter) => {
  if (isProperGutterType(gutter)) {
    return {
      className: mapGutterToClass(gutter),
    };
  }
  return {
    gridStyle: { marginLeft: `-${gutter / 2}px`, marginRight: `-${gutter / 2}px` },
    colStyle: { paddingLeft: `${gutter / 2}px`, paddingRight: `${gutter / 2}px` },
  };
};

/**
 * Col represents adaptive 12-grid-layout column, adaptivity is controled by size array
 *
 */
export default function Grid({ children, nowrap, gutter, className }) {
  const gutterData = getGutterData(gutter);
  return (
    <div
      className={cx('container', gutterData.className, { nowrap }, className)}
      style={gutterData.gridStyle}
    >
      <Provider value={gutterData}>{children}</Provider>
    </div>
  );
}

Grid.defaultProps = {
  gutter: 'medium',
};

Grid.propTypes = {
  children: PropTypes.node,
  nowrap: PropTypes.bool,
  gutter: PropTypes.oneOfType([
    PropTypes.oneOf(['collapse', 'small', 'medium', 'large']),
    PropTypes.number,
  ]),
  className: PropTypes.string,
};
